/* eslint max-classes-per-file: 0 */

import {
  VPRPublication as Data,
  VPRPublicationCollection as Collection,
  VPRPublicationPart as Part,
} from '@/typings/api/VPRPublications'
import { AxiosRequestConfig } from 'axios'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class VPRPublicationsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'vpr_publications';

  protected readonly hasFinishSlash = false;

  public generateKims(pId: Part['vpr_publication_id'], prId: Part['vpr_publication_part_id'], config: AxiosRequestConfig = {}) {
    const path = `/${pId}/${prId}/start_generation`
    const [url] = this.getUrl(path)
    return this.request('POST', url, { ...config })
  }
}

export class VPRQRCodesApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'vpr_qr_codes';

  protected readonly hasFinishSlash = false;
}

export class VPRVariantsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'vpr_variants';

  protected readonly hasFinishSlash = false;
}
